export interface Player {
  id: string;
  name: string;
  number: number;
  position: string;
  nationality: string;
  note: string;
}

export interface TeamSeasonStat {
  season: string;
  played: number;
  won: number;
  drawn: number;
  lost: number;
  goalsFor: number;
  goalsAgainst: number;
  topScorer: string;
}

export interface Team {
  id: string;
  name: string;
  englishName: string;
  city: string;
  country: string;
  founded: number;
  stadium: string;
  coach: string;
  colorHint: string;
  crest: string;
  summary: string;
  history: string;
  players: Player[];
  seasonStats: TeamSeasonStat[];
}

export const teams: Team[] = [
  {
    id: "man-city",
    name: "曼城",
    englishName: "Manchester City",
    city: "曼彻斯特",
    country: "英格兰",
    founded: 1880,
    stadium: "伊蒂哈德球场",
    coach: "佩普·瓜迪奥拉",
    colorHint: "天蓝",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20sky%20blue%20and%20navy%20with%20a%20circular%20shield%20shape%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition%2C%20crisp%20edges&width=400&height=400&seq=ucl-team-crest-man-city-01&orientation=squarish",
    summary:
      "曼城是近年来欧冠赛场最具统治力的球队之一，以极致的控球与高位压迫著称，中前场配合流畅，比赛节奏控制能力顶级。",
    history:
      "俱乐部成立于 1880 年，跨越三个世纪。2022-23 赛季球队首次捧起欧冠大耳朵杯，完成三冠王伟业，此后连续多个赛季稳居欧洲顶级行列。球队以传控体系与精准的引援眼光闻名，青训与数据分析体系同样处于欧洲领先水平。",
    players: [
      { id: "mc-1", name: "埃尔林·哈兰德", number: 9, position: "前锋", nationality: "挪威", note: "禁区内的终结机器，欧冠单赛季进球纪录保持者。" },
      { id: "mc-2", name: "凯文·德布劳内", number: 17, position: "中场", nationality: "比利时", note: "视野与传球精度顶级，球队进攻的组织核心。" },
      { id: "mc-3", name: "罗德里", number: 16, position: "后腰", nationality: "西班牙", note: "攻防转换的节拍器，拦截与出球同样出色。" },
      { id: "mc-4", name: "埃德森", number: 31, position: "门将", nationality: "巴西", note: "出球能力突出的现代门将，长传发动进攻。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 13, won: 9, drawn: 3, lost: 1, goalsFor: 31, goalsAgainst: 12, topScorer: "埃尔林·哈兰德" },
      { season: "2023-24", played: 12, won: 8, drawn: 2, lost: 2, goalsFor: 28, goalsAgainst: 14, topScorer: "埃尔林·哈兰德" },
      { season: "2022-23", played: 13, won: 10, drawn: 2, lost: 1, goalsFor: 36, goalsAgainst: 11, topScorer: "埃尔林·哈兰德" },
    ],
  },
  {
    id: "real-madrid",
    name: "皇家马德里",
    englishName: "Real Madrid",
    city: "马德里",
    country: "西班牙",
    founded: 1902,
    stadium: "伯纳乌球场",
    coach: "卡尔洛·安切洛蒂",
    colorHint: "纯白",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20white%20and%20gold%20with%20a%20royal%20crown%20silhouette%20and%20circular%20shield%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-real-madrid-01&orientation=squarish",
    summary:
      "欧冠历史上最成功的俱乐部，拥有最多的冠军奖杯。球队以强大的心理素质与关键战役的把握能力著称，反击效率极高。",
    history:
      "皇家马德里是欧冠赛场的绝对传奇，多次在决赛中逆转夺冠，形成了独特的“欧冠基因”。球队阵容兼顾经验与冲击力，中场控制力与边路速度结合，擅长在淘汰赛中后发制人，是任何对手都不愿面对的劲敌。",
    players: [
      { id: "rm-1", name: "维尼修斯", number: 7, position: "边锋", nationality: "巴西", note: "速度与突破能力极强，左路进攻的爆点。" },
      { id: "rm-2", name: "裘德·贝林厄姆", number: 5, position: "中场", nationality: "英格兰", note: "后插上得分能力突出，全能中场代表。" },
      { id: "rm-3", name: "安东尼奥·吕迪格", number: 22, position: "中卫", nationality: "德国", note: "对抗强硬，防守覆盖面积极大。" },
      { id: "rm-4", name: "蒂博·库尔图瓦", number: 1, position: "门将", nationality: "比利时", note: "身高臂长，关键扑救能力顶级。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 13, won: 9, drawn: 2, lost: 2, goalsFor: 27, goalsAgainst: 13, topScorer: "维尼修斯" },
      { season: "2023-24", played: 13, won: 10, drawn: 1, lost: 2, goalsFor: 26, goalsAgainst: 12, topScorer: "维尼修斯" },
      { season: "2022-23", played: 12, won: 8, drawn: 2, lost: 2, goalsFor: 25, goalsAgainst: 14, topScorer: "卡里姆·本泽马" },
    ],
  },
  {
    id: "bayern",
    name: "拜仁慕尼黑",
    englishName: "Bayern Munich",
    city: "慕尼黑",
    country: "德国",
    founded: 1900,
    stadium: "安联球场",
    coach: "文森特·孔帕尼",
    colorHint: "红色",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20red%20and%20white%20with%20a%20circular%20shield%20and%20vertical%20bavarian%20pattern%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-bayern-01&orientation=squarish",
    summary:
      "德甲班霸，欧冠赛场常年具备争冠实力。球队强调边中结合的立体进攻，身体对抗与前场逼抢强度都很高。",
    history:
      "拜仁慕尼黑是欧洲最具底蕴的俱乐部之一，六次捧起欧冠冠军。球队以稳定著称，长期保持联赛霸主地位，同时不断向欧洲之巅发起冲击，主场的压迫氛围也是球队的重要武器。",
    players: [
      { id: "by-1", name: "哈里·凯恩", number: 9, position: "前锋", nationality: "英格兰", note: "进球效率极高，回撤组织能力同样出色。" },
      { id: "by-2", name: "贾马尔·穆西亚拉", number: 42, position: "前腰", nationality: "德国", note: "盘带细腻，狭小空间内的创造力惊人。" },
      { id: "by-3", name: "约书亚·基米希", number: 6, position: "中场", nationality: "德国", note: "多面手，攻防两端贡献稳定。" },
      { id: "by-4", name: "曼努埃尔·诺伊尔", number: 1, position: "门将", nationality: "德国", note: "重新定义门将位置，出击范围极大。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 12, won: 8, drawn: 2, lost: 2, goalsFor: 29, goalsAgainst: 15, topScorer: "哈里·凯恩" },
      { season: "2023-24", played: 12, won: 7, drawn: 2, lost: 3, goalsFor: 24, goalsAgainst: 16, topScorer: "哈里·凯恩" },
      { season: "2022-23", played: 12, won: 8, drawn: 1, lost: 3, goalsFor: 27, goalsAgainst: 15, topScorer: "埃里克·马克西姆·舒波-莫廷" },
    ],
  },
  {
    id: "barcelona",
    name: "巴塞罗那",
    englishName: "FC Barcelona",
    city: "巴塞罗那",
    country: "西班牙",
    founded: 1899,
    stadium: "诺坎普球场",
    coach: "汉西·弗利克",
    colorHint: "蓝红",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20deep%20blue%20and%20crimson%20red%20with%20quarter%20shield%20design%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-barcelona-01&orientation=squarish",
    summary:
      "以拉玛西亚青训与传控足球闻名的传统豪门，善于通过高位压迫与快速短传撕开对手防线，年轻球员成长迅速。",
    history:
      "巴塞罗那的足球哲学影响了一代球迷，俱乐部长期坚持技术流打法。五次欧冠冠军的底蕴，加上源源不断的青训人才，让球队始终保持在欧洲顶级竞争序列之中。",
    players: [
      { id: "fc-1", name: "拉明·亚马尔", number: 19, position: "边锋", nationality: "西班牙", note: "天才少年，右路内切与传中威胁极大。" },
      { id: "fc-2", name: "佩德里", number: 8, position: "中场", nationality: "西班牙", note: "节奏掌控者，出球简洁高效。" },
      { id: "fc-3", name: "罗伯特·莱万多夫斯基", number: 9, position: "前锋", nationality: "波兰", note: "禁区嗅觉敏锐，欧冠历史级射手。" },
      { id: "fc-4", name: "马克-安德烈·特尔施特根", number: 1, position: "门将", nationality: "德国", note: "扑救反应快，脚下技术出色。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 13, won: 9, drawn: 1, lost: 3, goalsFor: 33, goalsAgainst: 18, topScorer: "罗伯特·莱万多夫斯基" },
      { season: "2023-24", played: 12, won: 6, drawn: 3, lost: 3, goalsFor: 22, goalsAgainst: 17, topScorer: "罗伯特·莱万多夫斯基" },
      { season: "2022-23", played: 8, won: 3, drawn: 2, lost: 3, goalsFor: 12, goalsAgainst: 13, topScorer: "罗伯特·莱万多夫斯基" },
    ],
  },
  {
    id: "psg",
    name: "巴黎圣日耳曼",
    englishName: "Paris Saint-Germain",
    city: "巴黎",
    country: "法国",
    founded: 1970,
    stadium: "王子公园球场",
    coach: "路易斯·恩里克",
    colorHint: "深蓝",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20navy%20blue%20and%20red%20with%20an%20eiffel%20tower%20silhouette%20and%20circular%20badge%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-psg-01&orientation=squarish",
    summary:
      "法甲霸主，近年完成阵容年轻化转型，前场三叉戟速度与个人能力兼备，中前场压迫强度出色。",
    history:
      "巴黎圣日耳曼是法国足球的名片，俱乐部在 2024-25 赛季终于圆梦欧冠，捧起队史首座大耳朵杯。球队在青训与引援之间找到了新的平衡，整体打法更具整体性。",
    players: [
      { id: "psg-1", name: "乌斯曼·登贝莱", number: 10, position: "边锋", nationality: "法国", note: "双足均衡，突破与终结兼备。" },
      { id: "psg-2", name: "维蒂尼亚", number: 17, position: "中场", nationality: "葡萄牙", note: "小范围配合与渗透传球出色。" },
      { id: "psg-3", name: "阿什拉夫·哈基米", number: 2, position: "右后卫", nationality: "摩洛哥", note: "往返能力强，右路进攻的重要发起点。" },
      { id: "psg-4", name: "詹路易吉·多纳鲁马", number: 99, position: "门将", nationality: "意大利", note: "身材高大，点球大战表现稳健。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 15, won: 11, drawn: 2, lost: 2, goalsFor: 34, goalsAgainst: 15, topScorer: "乌斯曼·登贝莱" },
      { season: "2023-24", played: 12, won: 7, drawn: 2, lost: 3, goalsFor: 24, goalsAgainst: 16, topScorer: "基利安·姆巴佩" },
      { season: "2022-23", played: 8, won: 4, drawn: 1, lost: 3, goalsFor: 15, goalsAgainst: 12, topScorer: "基利安·姆巴佩" },
    ],
  },
  {
    id: "man-utd",
    name: "曼联",
    englishName: "Manchester United",
    city: "曼彻斯特",
    country: "英格兰",
    founded: 1878,
    stadium: "老特拉福德球场",
    coach: "鲁本·阿莫林",
    colorHint: "红色",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20red%20and%20yellow%20with%20a%20shield%20and%20ship%20silhouette%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-man-utd-01&orientation=squarish",
    summary:
      "英超传统豪门，队史辉煌。球队强调边路进攻与快速反击，主场氛围极具压迫感。",
    history:
      "曼联三次捧起欧冠冠军，1999 年诺坎普之夜的补时逆转成为欧冠历史最经典的画面之一。俱乐部近年来持续重建，年轻化阵容正在逐步成型，重返欧洲之巅是长期目标。",
    players: [
      { id: "mu-1", name: "布鲁诺·费尔南德斯", number: 8, position: "前腰", nationality: "葡萄牙", note: "定位球与直塞球极具威胁，球队精神领袖。" },
      { id: "mu-2", name: "马库斯·拉什福德", number: 10, position: "边锋", nationality: "英格兰", note: "速度冲击力强，反击中的利刃。" },
      { id: "mu-3", name: "利桑德罗·马丁内斯", number: 6, position: "中卫", nationality: "阿根廷", note: "拼抢凶狠，出球能力出色。" },
      { id: "mu-4", name: "安德烈·奥纳纳", number: 24, position: "门将", nationality: "喀麦隆", note: "出球参与度高，反应速度快。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 10, won: 4, drawn: 3, lost: 3, goalsFor: 16, goalsAgainst: 15, topScorer: "布鲁诺·费尔南德斯" },
      { season: "2023-24", played: 6, won: 1, drawn: 1, lost: 4, goalsFor: 7, goalsAgainst: 12, topScorer: "拉斯穆斯·霍伊伦" },
      { season: "2022-23", played: 8, won: 4, drawn: 1, lost: 3, goalsFor: 13, goalsAgainst: 12, topScorer: "马库斯·拉什福德" },
    ],
  },
  {
    id: "inter",
    name: "国际米兰",
    englishName: "Inter Milan",
    city: "米兰",
    country: "意大利",
    founded: 1908,
    stadium: "梅阿查球场",
    coach: "西蒙尼·因扎吉",
    colorHint: "蓝黑",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20black%20and%20royal%20blue%20with%20concentric%20circles%20and%20star%20motif%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-inter-01&orientation=squarish",
    summary:
      "意甲劲旅，三中卫体系运用成熟，防守组织严密，反击犀利。定位球战术执行力强。",
    history:
      "国际米兰三夺欧冠冠军，2010 年穆里尼奥率队完成三冠王伟业。球队近年来重回欧洲强队行列，防反体系与整体纪律性是最大特点。",
    players: [
      { id: "in-1", name: "劳塔罗·马丁内斯", number: 10, position: "前锋", nationality: "阿根廷", note: "门前嗅觉一流，队长气质突出。" },
      { id: "in-2", name: "尼科洛·巴雷拉", number: 23, position: "中场", nationality: "意大利", note: "跑动覆盖面积大，推进能力强。" },
      { id: "in-3", name: "阿莱山德罗·巴斯托尼", number: 95, position: "中卫", nationality: "意大利", note: "左脚长传精准，后场出球核心。" },
      { id: "in-4", name: "扬·索默", number: 1, position: "门将", nationality: "瑞士", note: "扑救稳定，反应速度极快。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 13, won: 9, drawn: 2, lost: 2, goalsFor: 25, goalsAgainst: 11, topScorer: "劳塔罗·马丁内斯" },
      { season: "2023-24", played: 8, won: 3, drawn: 3, lost: 2, goalsFor: 10, goalsAgainst: 9, topScorer: "劳塔罗·马丁内斯" },
      { season: "2022-23", played: 13, won: 7, drawn: 3, lost: 3, goalsFor: 20, goalsAgainst: 12, topScorer: "埃丁·哲科" },
    ],
  },
  {
    id: "arsenal",
    name: "阿森纳",
    englishName: "Arsenal",
    city: "伦敦",
    country: "英格兰",
    founded: 1886,
    stadium: "酋长球场",
    coach: "米克尔·阿尔特塔",
    colorHint: "红白",
    crest: "https://readdy.ai/api/search-image?query=Stylized%20minimalist%20football%20club%20crest%20emblem%20in%20red%20and%20white%20with%20a%20cannon%20silhouette%20and%20shield%20shape%2C%20flat%20vector%20style%2C%20clean%20plain%20light%20gray%20background%2C%20centered%20composition&width=400&height=400&seq=ucl-team-crest-arsenal-01&orientation=squarish",
    summary:
      "英超劲旅，球队年轻且结构清晰，中场控制与定位球得分能力突出，整体战术执行力强。",
    history:
      "阿森纳近年来在年轻化重建中重新回到英超争冠行列，欧冠赛场的表现也稳步提升。球队强调位置感与传跑配合，防守端的整体性同样出色。",
    players: [
      { id: "ar-1", name: "布卡约·萨卡", number: 7, position: "边锋", nationality: "英格兰", note: "右路进攻核心，内切射门与传中兼备。" },
      { id: "ar-2", name: "马丁·厄德高", number: 8, position: "前腰", nationality: "挪威", note: "组织核心，关键传球次数常年居前。" },
      { id: "ar-3", name: "德克兰·赖斯", number: 41, position: "后腰", nationality: "英格兰", note: "拦截与推进兼备，定位球主罚手。" },
      { id: "ar-4", name: "大卫·拉亚", number: 22, position: "门将", nationality: "西班牙", note: "出球冷静，扑救反应敏捷。" },
    ],
    seasonStats: [
      { season: "2024-25", played: 13, won: 10, drawn: 2, lost: 1, goalsFor: 27, goalsAgainst: 8, topScorer: "布卡约·萨卡" },
      { season: "2023-24", played: 10, won: 6, drawn: 2, lost: 2, goalsFor: 18, goalsAgainst: 9, topScorer: "布卡约·萨卡" },
      { season: "2022-23", played: 6, won: 2, drawn: 1, lost: 3, goalsFor: 8, goalsAgainst: 10, topScorer: "加布里埃尔·热苏斯" },
    ],
  },
];